import { createContext, useContext, useMemo } from 'react'
import { canAccessWebModule } from '@_shared/helpers/helper.permissions'
import type { FleetWebUser, WebModule } from '@_shared/types'

type UserContextValue = {
  user: FleetWebUser
  canAccess: (webModule: WebModule) => boolean
}

const Context = createContext<UserContextValue>({ user: null, canAccess: () => false })

type UserProviderProps = {
  user?: FleetWebUser
  children: React.ReactNode
}

export const UserProvider = ({ user, children }: UserProviderProps) => {
  const value = useMemo(
    () => ({ user: user ?? null, canAccess: (webModule: WebModule) => canAccessWebModule(user, webModule) }),
    [user],
  )

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useUser = () => useContext(Context)
